<div class="login-sso bg-login" *ngIf="loginType === 'normal'">
    <div class="container-login container-login-sm bg-white relative w-100 flex justify-center items-center"
        style=" height: 100vh; overflow: hidden;">

        <div id="particles-js"
            style="position: absolute; width: 100%; height: 100%; top: 0; left: 0; z-index: 0; pointer-events: none;">
        </div>

        <div class="login-container login-container-sm flex flex-col lg:flex-row justify-start md:justify-between">

            <!--btn translate LG-->
            <div class=" absolute button-length sm-translate hidden lg:block">
                <msc-common-select [data]="selectData" class=" mobile-transparent-select">
                    <ng-template #buttonTemplate let-data="data">
                        <button class="btn-translate-login flex align-center text-gray-500 gap-1">
                            <ng-container *ngIf="data?.length">
                                <img class="mr-1 w-[24px] hidden"
                                    src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                <span>{{ data[0].label }}</span>
                            </ng-container>
                        </button>
                    </ng-template>
                    <ng-template #optionTemplate let-datum="datum">
                        <button class="flex align-center text-gray-500 gap-1" (click)="onSelectOption(datum)">
                            <img class="w-[24px] mr-1 hidden"
                                src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                            <span>{{ datum.label }}</span>
                        </button>
                    </ng-template>
                </msc-common-select>
            </div>

            <!-- Columna izquierda: imagen/fondo -->
            <div class=" contenedor-left shadow-xl rounded-xl flex col-6 m-0">
                <div class="left-column shadow-lg bg-login-gradient relative " *ngIf="loginType === 'normal'"
                    [style.backgroundImage]="'url(' + backgroundUrl + ')'"
                    [style.backgroundPosition]="backgroundPosition" (mousemove)="onMouseMove($event)"
                    (mouseleave)="resetBackgroundPosition()">

                    <!--
                <div class="left-column shadow-lg "
                    [style.backgroundImage]="'linear-gradient(180deg, rgba(0, 0, 0, 0.01) 0%, #36020c38 100%), url(' +
    (display?.background ? display.background + '?size=1024' : 'https://conocimiento.griky.co/hubfs/Imagenes%20de%20Blog%20%281%29.png') + ')'">-->

                    <div class="logo-container">
                        <div class="logo-wrapper ">
                            <div class="logo w-3/4 md:w-full" *ngIf="loginType === 'normal'"
                                [style.backgroundImage]="'url(' + logoUrl + ')'"></div>
                        </div>


                        <!--

                        <div class="logo" *ngIf="!display.logo"
                            [style.backgroundImage]="'url(https://webservices.griky.co/cdn/img/Griky-Logotipo.webp)'">
                        </div>
                        <div class="logo" *ngIf="display.logo"
                            [style.backgroundImage]="'url(' + display.logo + '?size=512)'"></div>
                            -->
                    </div>

                    <!--btn translate SM RESPONSIVE-->
                    <div class="lenguage-sm button-length sm-translate  block lg:hidden">
                        <msc-common-select [data]="selectData" class="mobile-transparent-select">
                            <ng-template #buttonTemplate let-data="data">
                                <button class="flex align-center text-gray-600 gap-1">
                                    <ng-container *ngIf="data?.length">
                                        <img class="mr-1 w-[24px] hidden"
                                            src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{data[0].value.code}}.svg">
                                        <span>{{ data[0].label }}</span>
                                    </ng-container>
                                </button>
                            </ng-template>
                            <ng-template #optionTemplate let-datum="datum">
                                <button class="flex align-center text-gray-500 gap-1" (click)="onSelectOption(datum)">
                                    <img class="w-[24px] mr-1 hidden"
                                        src="https://static.myskillcamp.com/images/icon/icon-camp/flag_{{datum.value.code}}.svg">
                                    <span>{{ datum.label }}</span>
                                </button>
                            </ng-template>
                        </msc-common-select>
                    </div>

                    <div class="text-container w-5/6 flex flex-col gap-2">
                        <h1 class="text-white text-xl sm:text-2xl md:text-3xl font-bold leading-tight">
                            {{ 'login.welcome' | translate }}
                            <span *ngIf="companyName">{{ companyName }}</span>
                        </h1>
                        <ng-container *ngIf="welcomeCustomMessage; else noWelcomeMessage">
                            <p
                                class="text-white text-sm sm:text-base md:text-lg leading-snug md:leading-normal message-img-login">
                                {{ welcomeCustomMessage }}</p>
                        </ng-container>
                        <ng-template #noWelcomeMessage>
                            <p
                                class="text-white text-sm sm:text-base md:text-lg leading-snug md:leading-normal message-img-login">
                                {{ 'login.message' | translate }}</p>
                        </ng-template>
                    </div>
                </div>
            </div>

            <!-- Columna derecha: Formulario y SSO -->

            <div class="contenedor-right contenedor-right-sm flex col-6 m-0 w-full">
                <div class="right-column flex justify-center px-8 md:p-0" *ngIf="!isValidating">
                    <!-- content -->
                    <ng-container *ngIf="!loader">
                        <h2 class="title-login text-xl my-4 lg:mb-6 text-gray-700">
                            {{ 'login.connect' | translate }}
                        </h2>
                    </ng-container>
                    <!-- <ng-template #notValidating class="content flex direction-column px-4"> -->
                    <div id="toggleButton" class="toggle-button relative cursor-pointer" (click)="toggleSwitcher()"
                        *ngIf="ssoList.length !== 0 && !loader">

                        <div [ngClass]="{ 'switcher-active': isOn }" id="switcher" class="switcher bg-primary absolute">
                            {{ isOn ? 'Email' : 'SSO' }}
                        </div>
                        <span [ngClass]="{ 'opacity-90': !isOn }" id="textOff" class="left">SSO</span>
                        <span [ngClass]="{ 'opacity-90': isOn }" id="textOn" class="right">Email</span>
                    </div>

                    <ng-container *ngIf="!loader">
                        <div class="content-login-form flex direction-column px-4">
                            <div class="login-message" *ngIf="message">
                                <div class="login-message" [ngStyle]="{'max-height': getMaxHeight()}">
                                    <div class="froala-view" [innerHTML]="message | safe: 'html'"></div>
                                </div>

                                <div class="login-message" (click)="displayedMessage()"
                                    [ngClass]="{'active': displayMessage}" *ngIf="hasDifferentHeight()">
                                    <i class="icon icon-arrow-ios-down"></i>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!loader">
                        <div class="content-login-form form-container">
                            <!-- SSO -->
                            <div id="formSSO" class="form-content my-3" *ngIf="!isOn">
                                <div *ngIf="ssoList.length !== 0" class="provider-options h-auto m-0">
                                    <div class="contenedor-sso">
                                        <div class="provider-title my-2 text-center hidden">
                                            <span>{{ ('login.sso' | translate) }}</span>
                                        </div>
                                        <div
                                            class="provider-options-container overflow-hidden align-center justify-center items-center flex align-center mx-auto px-4 gap-1">
                                            <!-- <ng-container *ngIf="!loader"> -->
                                            <a [href]="baseUrl + '/api/loginprovider/' + provider.uuid + '/' + id"
                                                class="provider-item text-gray-700 h-auto justify-center items-center flex align-center shadow-md border border-gray-100 p-3 gap-2"
                                                *ngFor="let provider of ssoList">
                                                <img *ngIf="provider.showIcon"
                                                    [src]="baseUrl + '/logo/' + provider.defaultIcon + '.svg'"
                                                    width="30" height="30" alt="Icon">
                                                <span>{{ provider.buttonInfo }}</span>
                                            </a>
                                            <!--  </ng-container> -->
                                            <!-- <ng-container *ngIf="loader">
                                                    <msc-common-spinner></msc-common-spinner>
                                                </ng-container> -->
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Email -->
                            <form class="block-login__form my-3" (ngSubmit)="login()"
                                *ngIf="ssoList.length === 0 || isOn">
                                <div id="formEmail" class="form-content mt-6 mb-3">
                                    <div class="block-login__input ">
                                        <msc-input name="email" id="login" autocomplete="on"
                                            [label]="'words.login-id' | translate" type="text"
                                            [(ngModel)]="credentials.email"></msc-input>
                                    </div>

                                    <div class="block-login__input" *ngIf="writePassword">
                                        <msc-input name="password" id="password" [label]="'words.password' | translate"
                                            type="password" [(ngModel)]="credentials.password">
                                        </msc-input>

                                    </div>

                                    <div class=" flex flex-col md:flex-row items-center justify-end">
                                        <a class="flex text-sm justify-center cursor-pointer md:justify-start md:w-3/5 lg:w-3/5 w-full text-gray-500"
                                            *ngIf="writePassword" (click)="passwordForgotten()">
                                            {{ 'words.password-forgotten' | translate }}
                                        </a>

                                        <div class="my-5 w-full md:w-2/5 lg:w-2/5 flex items-center justify-end">
                                            <msc-button htmlType="submit"
                                                [icon]="(!writePassword && !credentials.email) || (writePassword && (!credentials.email || !credentials.password)) ? null : 'fa-solid fa-arrow-right'"
                                                class="hover:text-white transition msc-button--primary w-full  custom-full-width"
                                                [loading]="loading" palette="secondary"
                                                [disabled]="(!writePassword && !credentials.email) || (writePassword && (!credentials.email || !credentials.password))">
                                                {{ writePassword ? ('words.login' | translate) : ('words.next' |
                                                translate)
                                                }}
                                            </msc-button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="loader">
                        <msc-common-spinner></msc-common-spinner>
                    </ng-container>
                    <!-- </ng-template> -->
                </div>
                <!--validating sso-->
                <div class="right-column flex justify-center" [ngClass]="{'login__body__providers': id}"
                    *ngIf='isValidating'>
                    <h2 class="block-login__title">
                        {{ 'login.validating' | translate }}
                    </h2>
                    <msc-common-spinner></msc-common-spinner>
                </div>
            </div>
        </div>
    </div>
</div>


<!--CUSTOM V3 COMPANY-->

<ng-container>
    <ng-container *ngIf="companies?.length === 1 && companies[0]?.roles?.length === 1; else companiesView">
        <div class="w-full h-full flex justify-center items-center">
            <msc-common-spinner></msc-common-spinner>
        </div>
    </ng-container>

    <ng-template #companiesView>
        <div class="p-6 mt-5 flex justify-center" *ngIf="loginType === 'company'">
            <div class="mx-auto max-w-7xl w-full">
                <!-- DESKTOP -->
                <!-- Encabezado con Botón de Regreso -->
                <div style="padding: 0px 5rem;" class="  hidden md:block">
                    <div class="relative mb-4 flex items-end justify-center">
                        <!-- Flecha atras -->
                        <button
                            class="absolute left-0 bottom-0 p-2.5 rounded-full bg-white border border-gray-200 text-gray-600 hover:bg-gray-100 transition-all shadow-sm"
                            aria-label="Volver" (click)="logout()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="rotate-180">
                                <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                                <polyline points="16 17 21 12 16 7" />
                                <line x1="21" x2="9" y1="12" y2="12" />
                            </svg>
                        </button>

                        <h1 class="text-2xl md:text-3xl font-semibold  text-gray-700">
                            {{ 'words.choose-space' | translate }}
                        </h1>
                    </div>

                    <!-- Descripción -->
                    <p
                        class="hidden text-sm font--normal  text-gray-400 max-w-lg mx-auto text-center mb-8 leading-relaxed">
                        {{ 'login.choose-space-description' | translate }}
                    </p>
                    <p class="text-[16px] text-gray-500 font-normal max-w-lg mx-auto leading-relaxed text-center mb-6">
                       {{ 'login.choose-space-subdescription' | translate }}</p>

                    <!-- Barra de Búsqueda -->
                    <div class="max-w-lg mx-auto mb-8">
                        <div class="relative group">
                            <div
                                class="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 group-focus-within:text-secondary transition-colors pointer-events-none">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8" />
                                    <path d="m21 21-4.3-4.3" />
                                </svg>
                            </div>
                            <input type="text" [placeholder]="'placeholder.search' | translate" class="search-input-login w-full h-10 pl-12 pr-4 rounded-full bg-white border border-gray-200 text-sm text-gray-700 shadow-sm transition-all focus:ring-0 focus:border-secondary placeholder:text-gray-400" (ngModelChange)="search(searchTerm)"
                                [(ngModel)]="searchTerm" />
                        </div>
                    </div>
                </div>
                <!--GRID CARDS COMAPNY DESKTOP-->
                <div class="relative hidden md:block">
                    <div class="flex flex-wrap justify-center gap-6 pt-2 pb-4 px-8 relative">
                        <div
                            class="relative grid w-full place-content-center auto-rows-auto gap-7 py-4 px-8 [grid-template-columns:repeat(auto-fit,minmax(200px,200px))]">
                            <div *ngFor="let company of companies; let index=index"
                                (mouseenter)="selectCompany(company)"
                                class="relative flex justify-center w-[200px] h-28  ">

                                <div
                                    class="card-company z-0 hover:z-10 group relative w-[200px] h-28  hover:h-48  transition-all duration-500 ease-in-out overflow-hidden  bg-white border-2 border-gray-200 rounded-[15px] shadow-sm">
                                    <!-- LOGO -->
                                    <div class="absolute inset-0 z-10 flex items-end justify-center w-full h-full">
                                        <div
                                            class="absolute inset-0 z-10 hover:z-0 flex items-center justify-center w-full h-full transition-all duration-500 ease-in-out  group-hover:top-0 group-hover:translate-y-[-20%]">
                                            <img [src]="getCompanyLogo(company)" [attr.alt]="company.name"
                                                class="max-w-[100%] max-h-[80%] img-card-hover object-contain truncate  group-hover:bg-gray-50 rounded-lg block p-4" />
                                        </div>
                                    </div>


                                    <!-- TEXTO + ICONOS -->
                                    <div
                                        class="absolute inset-0 hover:z-10 flex flex-col items-center justify-between py-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                        <!-- Espacio vacío arriba para que el texto quede centrado -->
                                        <div class="h-4-5"></div>

                                        <!-- TÍTULO -->
                                        <p class="company-name text-md text-gray-600 font-medium text-center px-2 z-20"
                                            [tooltip]="(company?.experience?.displayName !== company?.name && company?.experience?.displayName) ? company?.experience?.displayName : company?.name">
                                            {{ (company?.experience?.displayName !== company?.name &&
                                            company?.experience?.displayName) ? company?.experience?.displayName :
                                            company?.name
                                            }}
                                        </p>

                                        <!-- ICONOS DE ROLES -->
                                        <div class="flex gap-2 relative z-20">
                                            <!-- Aprender -->
                                            <div class="relative" *ngIf="isRole('company_learner')"
                                                (click)="redirect('learn')">
                                                <button [tooltip]="'words.learn' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class="icon icon-student "></i>
                                                    <!--  <i class="fa-solid fa-graduation-cap fa-xs"></i>-->
                                                </button>
                                            </div>
                                            <!-- Crar -->
                                            <div class="relative" *ngIf="isRole('company_author')"
                                                (click)="redirect('create')">
                                                <button [tooltip]="'words.create' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class=" icon icon-color-palette "></i>
                                                    <!--  <i class="fa-solid fa-pencil-alt fa-xs"></i>-->
                                                </button>
                                            </div>
                                            <!-- Acompañar -->
                                            <div class="relative" *ngIf="isRole('company_manager')"
                                                (click)="redirect('manage')">
                                                <button [tooltip]="'words.coach' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class="icon icon-mentor "></i>
                                                    <!-- <i class="fa-solid fa-users  fa-xs"></i> -->
                                                </button>
                                            </div>
                                            <!-- Administrar -->
                                            <div class="relative" *ngIf="isRole('company_administrator')"
                                                (click)="redirect('organize')">
                                                <button [tooltip]="'words.organise' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class=" icon icon-calendar "></i>
                                                    <!--  <i class="fa-solid fa-user-tie fa-xs"></i>-->
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

                <!-- RESPONSIVE -->
                <!-- Flecha y buscador RESPONSIVE -->
                <div class="block md:hidden">
                    <div class="flex flex-row gap-2 justify-start items-center border-b pb-2">
                        <!-- Flecha atras -->
                        <button
                            class="btn-icon btn-transition hover:shadow-md text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-start transition bg-white "
                            (click)="logout()">
                            <i
                                class="fa-solid fa-chevron-left w-5 h-5 text-sm text-gray-400 flex  items-center justify-center"></i>
                        </button>
                        <div>
                            <h1 class="block md:hidden text-lg md:text-xl  text-gray-700">{{
                                'words.choose-space' | translate }}</h1>
                        </div>
                    </div>
                </div>
                <div class="block md:hidden my-6">
                    <div
                        class=" bg-white rounded-[10px] px-1 flex items-center w-full md:w-72  md:mt-0  border-[1px] shadow-sm border-gray-200">
                        <input type="text" [placeholder]="'placeholder.search' | translate"
                            class="flex-grow p-2 focus:outline-none font-[400] rounded-[10px] text-sm"
                            (ngModelChange)="search(searchTerm)" [(ngModel)]="searchTerm" />
                        <button class="bg-white p-2 rounded-r-lg">
                            <i class="fa-solid fa-magnifying-glass text-gray-400"></i>
                        </button>
                    </div>
                </div>
                <!-- SLIDER CADS COMPANY RESPONSIVE SM -->
                <div class="swiper-container block md:hidden py-4">
                    <!-- Controles en la parte superior -->
                    <div class="flex justify-between items-center px-8 py-2">
                        <div
                            class="swiper-button-prev flex items-center gap-2 text-sm text-gray-500  cursor-pointer relative w-auto">
                            <i class="fa-solid fa-arrow-left-long text-base"></i>
                            <span>{{ 'word.previous' | translate }} </span>
                        </div>
                        <div
                            class="swiper-button-next flex items-center gap-2 text-sm cursor-pointer text-gray-500 relative w-auto">
                            <span>{{ 'common.next' | translate }}</span>
                            <i class="fa-solid fa-arrow-right-long text-base"></i>
                        </div>
                    </div>

                    <div class="swiper-wrapper">
                        <div class="swiper-slide" *ngFor="let company of companies; let index = index">
                            <!-- CARD -->
                            <div (mouseenter)="selectCompany(company)" class="relative flex justify-center w-full h-28">
                                <div
                                    class="card-company z-0 hover:z-10 group relative w-3/4 h-28 hover:h-48 transition-all duration-500 ease-in-out overflow-hidden bg-white border-2 border-gray-200 rounded-[15px] shadow-sm">

                                    <!-- Logo -->
                                    <div class="absolute inset-0 z-10 flex items-end justify-center w-full h-full">
                                        <div
                                            class="absolute inset-0 z-10 hover:z-0 flex items-center justify-center w-full h-full transition-all duration-500 ease-in-out group-hover:top-0 group-hover:translate-y-[-20%]">
                                            <img [src]="getCompanyLogo(company)" [attr.alt]="company.name"
                                                class="max-w-[100%] max-h-[80%] img-card-hover object-contain truncate group-hover:bg-gray-50 rounded-lg block p-4" />
                                        </div>
                                    </div>

                                    <!-- Texto + Iconos -->
                                    <div
                                        class="absolute inset-0 hover:z-10 flex flex-col items-center justify-between py-6 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                                        <div class="h-4-5"></div>
                                        <p class="company-name text-md text-gray-600 font-medium text-center px-2 z-20"
                                            [tooltip]="(company?.experience?.displayName !== company?.name && company?.experience?.displayName) ? company?.experience?.displayName : company?.name">
                                            {{
                                            (company?.experience?.displayName !== company?.name &&
                                            company?.experience?.displayName) ?
                                            company?.experience?.displayName :
                                            company?.name
                                            }}
                                        </p>

                                        <!-- ICONOS DE ROLES -->
                                        <div class="flex gap-2 relative z-20">
                                            <!-- Aprender -->
                                            <div class="relative" *ngIf="isRole('company_learner')"
                                                (click)="redirect('learn')">
                                                <button [tooltip]="'words.learn' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class="icon icon-student "></i>
                                                    <!--  <i class="fa-solid fa-graduation-cap fa-xs"></i>-->
                                                </button>
                                            </div>
                                            <!-- Crar -->
                                            <div class="relative" *ngIf="isRole('company_author')"
                                                (click)="redirect('create')">
                                                <button [tooltip]="'words.create' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class=" icon icon-color-palette "></i>
                                                    <!--  <i class="fa-solid fa-pencil-alt fa-xs"></i>-->
                                                </button>
                                            </div>
                                            <!-- Acompañar -->
                                            <div class="relative" *ngIf="isRole('company_manager')"
                                                (click)="redirect('manage')">
                                                <button [tooltip]="'words.coach' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class="icon icon-mentor "></i>
                                                    <!-- <i class="fa-solid fa-users  fa-xs"></i> -->
                                                </button>
                                            </div>
                                            <!-- Administrar -->
                                            <div class="relative" *ngIf="isRole('company_administrator')"
                                                (click)="redirect('organize')">
                                                <button [tooltip]="'words.organise' | translate"
                                                    class="tooltip-btn  group hover:shadow-md  text-gray-500 relative w-8 h-8 rounded-full flex items-center justify-center transition">
                                                    <i class=" icon icon-calendar "></i>
                                                    <!--  <i class="fa-solid fa-user-tie fa-xs"></i>-->
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Opcional: Paginación y navegación -->
                    <div class="swiper-pagination z-0 absolute bottom-[-10px] left-0 w-full"></div>
                </div>

            </div>
        </div>
    </ng-template>
</ng-container>